import React from "react";

function Color_Palettes() {
  return (
    <div>
      <h1>Color_Palettes Component</h1>
      <p>This is the Color Palettes tutorial page content.</p>
    </div>
  );
}

export default Color_Palettes;
